import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ClaimActivity } from '../../models';

@Component({
  selector: 'ds-claim-activity',
  templateUrl: './claim-activity.component.html',
  styleUrls: ['./claim-activity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimActivityComponent implements OnInit {
  @Input() activityData: ClaimActivity[];

  public displayedActivity: ClaimActivity[];
  private initialActivityNumber = 3;

  constructor() {}

  ngOnInit() {
    this.toggleRecentItemsDisplay(this.initialActivityNumber);
  }

  toggleRecentItemsDisplay(numberOfItems: number = this.activityData.length) {
    this.displayedActivity = this.activityData.slice(0, numberOfItems);
  }
}
